import axios from "axios";
//import drop from "lodash/drop";
import event from "./event";

//const domain = drop(window.location.hostname.split(".")).join(".");
const domain = window.location.hostname;

const cb = response => {
  const status = response.data.status;
  if (status !== 0) {
    if (status === 10) {
      event.broadcast("login", response.data);
    } else {
      event.broadcast("error", response.data);
    }
    return Promise.reject({
      message: response.data
    });
  } else {
    // 服务端一切正常 返回data数据
    return response.data;
  }
};

let exp = {};
let instances = {};

const conf = {
  admin: "//api." + domain + "/admin/",
  front: "//api." + domain + "/front/",
  activity: "//api." + domain + "/activity/",
  product: "//api." + domain + "/product/",
  agent: "//api." + domain + "/agent/",
  partner: "//api." + domain + "/partner/",
  stat: "//api." + domain + "/statistics/",
  cms: `//api.${domain}/cms`,
  test: "//test." + domain + "/",
  tools: "//api." + domain + "/tools/",
  shop: "//api." + domain + "/shop/",
  aliyun: `//api.${domain}/aliyun/`,
  wallet: `//api.${domain}/wallet/`,
  messenger: `//api.${domain}/messenger`,
  vm: `//api.${domain}/`,
  erp: `//api.${domain}/erp`,
  uc: `//api.${domain}/uc`,
  policy: `//api.${domain}/policy`,
  cs: `//api.${domain}/cs`, 
  library: `//api.${domain}/product_new/`,
    saas: `//api.${domain}/saas/`,
    internal: `//api.${domain}/internal/`,
    common: `//api.${domain}/internal/`
};

////http://api.admin.vm33.finadv.cn/product_new/to_type.php
for (let s in conf) {
  let target;
  if (s === "") {
    target = exp;
  } else {
    exp[s] = {};
    target = exp[s];
  }

  let baseURL = conf[s];

  instances[s] = axios.create({
    baseURL: baseURL,
    withCredentials: true
  });
  instances[s].interceptors.response.use(cb);

  target["baseURL"] = baseURL;
  target["post"] = function(url, args) {
    const req = {
      method: "POST",
      url: url + ".php",
      params: {},
      data: JSON.stringify(args)
    };
    return instances[s].request(req);
  };
}

exp["logged_in"] = function() {
  return exp.admin.post("login_check", {});
};

export default exp;
